import type { SvgPropsInterface } from "@/types/common/ImageInterface";
import { ColorMain } from "@/types/styles/designSystemEnum";

const Information = ({
  width = "24",
  height = "24",
  color = ColorMain.DARK_GREY,
}: SvgPropsInterface) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0005 22C6.48633 22 2 17.5142 2 12C2 6.48584 6.48584 2 12 2C17.5142 2 22 6.48584 22 12C22 17.5142 17.5142 22 12.0005 22ZM12.0005 3C7.03759 3 3 7.0376 3 12C3 16.9624 7.0376 21 12 21C16.9624 21 21 16.9624 21 12C21 7.0376 16.9629 3 12.0005 3Z"
        fill={color}
      />
      <path
        d="M12 16.5876C11.7236 16.5876 11.5 16.3639 11.5 16.0876V11.5C11.5 11.2236 11.7236 11 12 11C12.2764 11 12.5 11.2236 12.5 11.5V16.0876C12.5 16.3639 12.2764 16.5876 12 16.5876Z"
        fill={color}
      />
      <path
        d="M11.9961 8.99869C11.8662 8.99869 11.7358 8.93863 11.646 8.84879C11.5561 8.75895 11.5058 8.62858 11.5058 8.49869C11.5058 8.42887 11.5161 8.35855 11.5361 8.29898C11.5659 8.23892 11.6059 8.18863 11.646 8.13882C11.8359 7.94888 12.166 7.95864 12.3559 8.13882C12.396 8.18862 12.436 8.23892 12.4663 8.29898C12.4858 8.35855 12.4961 8.42886 12.4961 8.49869C12.4961 8.62857 12.4463 8.75894 12.3559 8.84879C12.2661 8.93863 12.1362 8.99869 11.9961 8.99869Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8307 8.30813C11.8015 8.34476 11.7823 8.37028 11.7683 8.39473C11.7608 8.423 11.7558 8.45929 11.7558 8.49871C11.7558 8.56794 11.7836 8.63291 11.8228 8.67202C11.8708 8.72002 11.9393 8.74871 11.9961 8.74871C12.0655 8.74871 12.133 8.71818 12.1792 8.67203C12.2179 8.63349 12.2461 8.56853 12.2461 8.49871C12.2461 8.4599 12.2412 8.42359 12.2339 8.39469C12.2198 8.37058 12.201 8.34554 12.1734 8.31088C12.0758 8.22886 11.9167 8.23154 11.8307 8.30813ZM11.4692 7.96206C11.7623 7.66897 12.2475 7.69133 12.528 7.95746L12.5402 7.96906L12.5532 7.98524C12.5917 8.03304 12.6467 8.10141 12.6895 8.18648L12.698 8.20326L12.7038 8.22111C12.7328 8.30928 12.7461 8.40632 12.7461 8.49871C12.7461 8.68864 12.6742 8.88491 12.5322 9.02606C12.3987 9.1596 12.2069 9.24871 11.9961 9.24871C11.7931 9.24871 11.6009 9.15727 11.4692 9.02559C11.3286 8.88502 11.2558 8.68925 11.2558 8.49871C11.2558 8.40643 11.2691 8.30864 11.2991 8.21936L11.3046 8.20319L11.3122 8.18791C11.3547 8.10209 11.4101 8.03321 11.4485 7.98552C11.4494 7.9844 11.4503 7.9833 11.4511 7.98221L11.4596 7.97164L11.4692 7.96206ZM12 11.25C11.8617 11.25 11.75 11.3617 11.75 11.5V16.0876C11.75 16.2259 11.8617 16.3376 12 16.3376C12.1383 16.3376 12.25 16.2259 12.25 16.0876V11.5C12.25 11.3617 12.1383 11.25 12 11.25ZM11.25 11.5C11.25 11.0856 11.5856 10.75 12 10.75C12.4144 10.75 12.75 11.0856 12.75 11.5V16.0876C12.75 16.502 12.4144 16.8376 12 16.8376C11.5856 16.8376 11.25 16.502 11.25 16.0876V11.5Z"
        fill={color}
      />
    </svg>
  );
};

export default Information;
